import React from 'react';
import PropTypes from 'prop-types';
import tc from 'tinycolor2';
import { SanitizeHtml } from '@bd/bdcore-utilities';
import { css } from '@bd/bdui-styles/emotion';
import { colors, typography } from '../../styles';

const styles = css`
  font-family: ${typography.SanSerif};
  font-weight: normal;
  font-size: 14px;
  padding: 28px 32px;
  margin: 36px -14px 0;
  position: relative;
  z-index: 0;
  background-color: ${tc.mix(colors.color3, 'white', 80).toString()};
  &::after {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 14px;
    height: 100%;
    z-index: 1;
    background-color: ${tc.mix(colors.color3, 'white', 20).toString()};
  }
  @media (min-width: 360px) {
    padding-left: 54px;
    padding-right: 54px;
    margin-left: -27px;
    margin-right: -27px;
  }
  @media (min-width: 768px) {
    font-size: 16px;
    clear: both;
    padding: 21px 36px 30px 60px;
    margin: 0;
    max-width: 1050px;
    &::after {
      width: 36px;
    }
  }
  @media (min-width: 992px) {
    font-size: 18px;
    padding: 24px 42px 36px 68px;
    &::after {
      width: 42px;
    }
  }
  .AgentBio_bio {
    position: relative;
    z-index: 2;
    img {
      display: block;
      max-width: 100%;
    }
    p, ul, ol {
      margin-bottom: 1.5em;
    }
    p {
      line-height: 1.875;
      img {
        margin-top: 1.5em;
      }
    }
    ul, ol {
      line-height: 1.5;
      @media (max-width: 767.98px) {
        padding-left: 25px;
      }
      li:not(:last-child) {
        margin-bottom: 0.85em;
      }
      img {
        margin-top: 0.85em;
      }
    }
    a {
      font-weight: bold;
      text-decoration: underline;
      &:active {
        color: ${colors.color1Light};
      }
      &:focus {
        color: ${colors.color1Light};
        outline: 1px dashed ${colors.color3};
        outline-offset: 1px;
      }
      @media (min-width: 992px) {
        &:hover {
          color: ${colors.color1Light};
        }
      }
    }
    > :last-child {
      margin-bottom: 0;
    }
  }
`;


function AgentBio({ bio }) {
  return (
    <div className={styles}>
      <div className="AgentBio_bio" dangerouslySetInnerHTML={SanitizeHtml(bio)} />
    </div>
  );
}

AgentBio.propTypes = {
  bio: PropTypes.string.isRequired,
};

export default AgentBio;



// WEBPACK FOOTER //
// ./src/pages/AgentDetail/AgentBio.js